const expenseItemFields = [
  'infoMedicalExpensesItems',
  'infoOpticalTreatmentItems',
  'infoAncillaryServicesItems',
  'infoMentalHealthItems',
  'infoSexualHealthItems',
  'infoExtraTravelAndAccommodationItems',
  'infoSearchAndRescueItems',
  'infoUrgentCareOutOfHoursVisitsItems',
  'infoPrescriptionsItems',
  'infoGPVisitsItems',
  'infoRehabilitationAndOccupationalTherapyItems',
  'infoMaternityCareItems',
  'infoReplacementStaffItems',
  'infoRepatriationBenefitItems',
  'infoOtherMedicalExpensesItems',
  'infoMedicalExpensesHospitalisedItems',
  'infoMedicalExpensesCompanionItems',
  'infoDentalExpensesItems',
  'infoFuneralExpensesItems',
  'infoTheDeathCausedByAnInjuryItems',
  'infoExpensesArisingFromTerrorismItems',
];

export const hasAnyMedicalAndEvacuationExpenseItems = (form = {}) =>
  expenseItemFields.some((field) => Array.isArray(form[field]) && form[field].length > 0);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/validation.js